import { ROW_COL_SPAN } from '@modules/dashboard/constants';
import { getDashboardRow } from '@modules/dashboard/helpers/getDashboardRow';
import { DashboardState } from '@modules/dashboard/store/types';
import { cloneDeep } from 'lodash';

interface removeContentFromMetadataParams {
  metadata: DashboardState['metadata'];
  contentID: string;
}

export function removeContentFromMetadata({
  metadata,
  contentID,
}: removeContentFromMetadataParams) {
  const metadataClone = cloneDeep(metadata);

  if (metadataClone.analysesMetadata) {
    const contentIndex = metadataClone.analysesMetadata.findIndex(
      (analysis) => analysis.id === contentID,
    );

    if (contentIndex !== -1) {
      metadataClone.analysesMetadata.splice(contentIndex, 1);
    }
  }

  if (metadataClone.layout) {
    let dirtyRowID = '';
    let dirtyCellIndex = -1;
    const rows = metadataClone.layout.rows;

    rows.forEach((row) => {
      row.cells.forEach((cell, index) => {
        if (cell.contentID === contentID) {
          dirtyRowID = row.id;
          dirtyCellIndex = index;
        }
      });
    });

    if (dirtyCellIndex >= 0) {
      const dirtyRow = getDashboardRow({
        rowID: dirtyRowID,
        rows,
      });

      if (dirtyRow) {
        dirtyRow.cells.splice(dirtyCellIndex, 1);

        if (!!dirtyRow.cells.length) {
          dirtyRow.cells.forEach((cell) => {
            cell.columnSpan = ROW_COL_SPAN / dirtyRow.cells.length;
          });
        } else {
          rows.splice(rows.indexOf(dirtyRow), 1);
        }
      }
    }
  }

  return metadataClone;
}
